const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/settings/people/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';
import { requirePermission } from '@/lib/hooks/common/usePermissions';
import i18n from '@/lib/translations/i18n';
import { ensureNamespaceLoaded } from '@/lib/translations/i18nloader';
const peopleSearchSchema = z.object({
  dialog: z.enum(['createMember']).optional()
});
export const Route = createFileRoute('/(app)/org/$org/settings/people')({
  validateSearch: zodValidator(peopleSearchSchema),
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  beforeLoad: async ctx => {
    await requirePermission('edit_capacity')(ctx);
    await ensureNamespaceLoaded('teams');
  },
  loader: (): LoaderData => ({
    crumb: i18n.t($ => $.common.people)
  })
});